<template>
  <CSpin v-if="apiState.isFetchingRecentFiles" class="flex h-full" />
  <div v-else class="w-full h-full" :class="{ 'pr-3': isContentPanelOpen }">
    <CList
      class="favorites-table rounded-2 flex bg-base"
      :data="displayedRecentFiles"
      :maxRowHeight="150"
      :selectedIds="selectedItemIds"
      @item:click="openItem"
    >
      <template #item="{ item, isSelected, isDraggedOver, isContextMenuOpen }">
        <BrowserListItem
          :filters="computed(() => ({}) as Record<string, any>)"
          :highlight-text="apiState.searchQuery"
          :is-context-menu-open="isContextMenuOpen"
          :is-dragged-over="isDraggedOver"
          :is-selected="isSelected"
          :item="item"
          :metadata="processedMetadata[item.id] || {}"
          :style="{ opacity: item.opacity || 1 }"
        >
          <template #actions>
            <FileDetailsPanelButton :item="getTypedItem(item)" />
            <FavoriteButton :item="getTypedItem(item)" />
          </template>
        </BrowserListItem>
      </template>
    </CList>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue'

import BrowserListItem from '@browser/components/Content/Common/BrowserListItem.vue'
import CList from '@lib/components/CList/CList.vue'
import CSpin from '@lib/components/CSpin/CSpin.vue'
import FavoriteButton from '@browser/components/ContextMenu/FavoriteButton.vue'
import FileDetailsPanelButton from '@browser/components/ContextMenu/FileDetailsPanelButton.vue'

import useApiStore from '@browser/stores/api'
import useAppStore from '@browser/stores/app'
import useMetadataTemplates from '@lib/composables/useMetadataTemplates'

import { openItem } from '@browser/util/file'

import type { ViewCompactFolder } from '@lib/types/files'

const { state: apiState } = useApiStore()
const { selectedItemIds, isContentPanelOpen, displayedRecentFiles } = useAppStore()

// Initialize metadata templates with the items ref directly
const { processedMetadata, fetchTemplate } = useMetadataTemplates({
  itemsRef: displayedRecentFiles,
})

const getTypedItem = (item: any) => item as ViewCompactFolder

// Fetch metadata templates on mount
onMounted(async () => {
  await fetchTemplate()
})
</script>
